<template>
  <div
    v-if="backgroundUrl"
    class="guide"
    :style="{
      backgroundImage: `url(${backgroundUrl})`,
      backgroundColor: backgroundColor
    }"
  >
    <div
      v-if="bankLogo[bankType]"
      class="guide-logo"
      :style="{
        backgroundImage: `url(${bankLogo[bankType]})`
      }"
    ></div>
    <div class="guide-rule" @click="goActivityRules"></div>
    <div class="guide-title" v-if="title && title.length > 0">
      <span v-for="item in title">
        <span v-if="item.type === 'dynamic'" :style="item.style">{{
          bankInfo[item.value]
        }}</span>
        <span v-if="item.type === 'static'" :style="item.style">
          {{ item.value }}
        </span>
      </span>
    </div>
    <div class="guide-subTitle" v-if="subTitle && subTitle.length > 0">
      <div class="guide-subTitle__left"></div>
      <div v-for="item in subTitle" class="guide-subTitle__middle">
        <span v-if="item.type === 'dynamic'" :style="item.style">
         {{ bankInfo[item.value] }}
        </span>
        <span v-if="item.type === 'static'" :style="item.style">
          {{ item.value }}
        </span>
      </div>
      <div class="guide-subTitle__right"></div>
    </div>
    <simpleness
      v-if="guideComponent === 'miniPageT0'"
      :mobileMask="mobileMask"
      :currentBankHasBinding="currentBankHasBinding"
      :hasOpenThatBank="hasOpenThatBank"
      :bankName="bankInfo.bankName"
      :bankType="bankType"
      :couponPackage="couponPackage"
      :applyPageType="applyPageType"
      :pageABStrategy="pageABStrategy"
      :pushSubWalletABStrategy="pushSubWalletABStrategy"
      :couponImgForTOConfig="couponImgForTOConfig"
    />
    <simpleness-show-rights
      v-if="guideComponent === 'miniPageStrategyRights'"
      :mobileMask="mobileMask"
      :currentBankHasBinding="currentBankHasBinding"
      :hasOpenThatBank="hasOpenThatBank"
      :bankName="bankInfo.bankName"
      :bankType="bankType"
      :couponPackage="couponPackage"
      :applyPageType="applyPageType"
      :pageABStrategy="pageABStrategy"
      :pushSubWalletABStrategy="pushSubWalletABStrategy"
      :couponImgForTNConfig="couponImgForTNConfig"
    />
  </div>
</template>
<script>
/* eslint-disable */
import { monitor } from '@/common/monitor';
import { env } from '@/common/env';
import { api } from '@/common/api';
import { fetchGuideContentForAct } from '@/common/horn';
import { lxConfig } from '@/analytic/guideConfig';
import { lx } from '@/analytic/index';
import { lowCarbonActivityGroupName, maicaiActivityGroupName, groupNameMapForHorn } from '@/common/config';
import ToastUtil from '@/tools/ToastUtil';
import { getUrlQuery } from '@/common/utils';
import Simpleness from './Simpleness_T0.vue';
import SimplenessShowProduct from './SimplenessShowProduct_Tn.vue';
import SimplenessShowRights from './SimplenessShowRights_Tn.vue';
import { reportEachPageTTI } from '@/common/utils';

export default {
  components: {
    Simpleness,
    SimplenessShowProduct,
    SimplenessShowRights
  },
  props: [ 'actGroupName', 'actId', 'actName'],
  data() {
    return {
      downloadExperimentABStrategy: '',
      backgroundUrl: '',
      backgroundColor: '',
      mobileMask: null,
      hasOpenThatBank: false,
      currentBankHasBinding: false,
      activityRuleUrl: '',
      couponPackage: {},
      pageABStrategy: '',
      applyPageType: '',
      bankLogo: {},
      couponImgForTOConfig: {},
      couponImgForTNConfig: {},
      bannerConfig: {},
      pushSubWalletABStrategy: null,
      bankType: '',
      resource: {},
      bankList: []
    };
  },
  computed: {
    activityName() {
      return this.actName || env.actName;
    },
    activityGroupName() {
      return this.actGroupName || env.actGroupName || lowCarbonActivityGroupName;
    },
    activityId() {
      return this.actId || env.actId;
    },
    bankInfo() {
      const filterArr = this.bankList.filter(item => {
        return item.payType === this.bankType
      }) || [];
      return filterArr[0] || {};
    },
    title() {
      if (this.currentBankHasBinding) {
        return this.bannerConfig && this.bannerConfig.hasBind && this.bannerConfig.hasBind.title;
      }
      if (this.hasOpenThatBank) {
        return this.bannerConfig && this.bannerConfig.hasOpen && this.bannerConfig.hasOpen.title;
      }
      return this.bannerConfig && this.bannerConfig.notOpen && this.bannerConfig.notOpen.title;
    },
    subTitle() {
      if (this.currentBankHasBinding) {
        return this.bannerConfig && this.bannerConfig.hasBind && this.bannerConfig.hasBind.subTitle;
      }
      if (this.hasOpenThatBank) {
        return this.bannerConfig && this.bannerConfig.hasOpen && this.bannerConfig.hasOpen.subTitle;
      }
      return this.bannerConfig && this.bannerConfig.notOpen && this.bannerConfig.notOpen.subTitle;
    },
    guideComponent() {
      if (this.applyPageType === 'T+N') {
        // T+N全量权益版本
        return 'miniPageStrategyRights';
      }
      if (this.applyPageType === 'T0') {
        return 'miniPageT0';
      }
      return '';
    },
    userStatus() {
      if (this.currentBankHasBinding) {
        return '已推子';
      }
      if (this.hasOpenThatBank) {
        return '开通未推子';
      }
      if (!this.hasOpenThatBank) {
        return '报名未开通';
      }
    }
  },
  async created() {
    await this.init();
    // 页面TTI上报
    reportEachPageTTI();
    lx.pv(lxConfig.pv, {
      abtest: this.pageABStrategy,
      from: env.from,
      page_type: this.applyPageType,
      user_status: this.userStatus || -999
    });
    this.$bridge.subscribe('appear', () => {
      this.initBusinessInfo();
    });
    this.$bridge.subscribe('foreground', () => {
      this.initBusinessInfo();
    });
  },
  mounted() {
    this.$bridge.setTitle('数字人民币开通/使用攻略');
  },
  methods: {
    async handleEcnyAppCallback() {
      // 判断是不是来源于一键推子回调
      if (!this.isFromEcnyApp()) {
        return;
      }
      const urlQuery = getUrlQuery();
      const sign = urlQuery && urlQuery.sign;
      const signInfo = urlQuery && urlQuery.signInfo;
      const res = await this.dealReverseBindWalletRespInfo(
        decodeURIComponent(sign),
        decodeURIComponent(signInfo)
      );
      if (!res || res.push_code.toUpperCase() !== 'OK') {
        const message = res.push_msg || '推子失败，请稍后重试';
        ToastUtil.show(message);
        monitor.captureMessage(
          {
            name: '【一键推子失败】',
            msg: JSON.stringify(message)
          },
          {
            level: 'warn'
          }
        );
      }
    },
    isFromEcnyApp() {
      const urlQuery = getUrlQuery();
      const openFromEcny = urlQuery && urlQuery.openFromEcny;
      if (openFromEcny) {
        return true;
      }
      return false;
    },
    async dealReverseBindWalletRespInfo(sign, signInfo) {
      try {
        const res = await api.dealReverseBindWalletRespInfo(sign, signInfo)
        return res;
      } catch (err) {
        return '';
      }
    },
    // 初始化业务信息和素材配置
    async init() {
      Promise.all([this.initBusinessInfo(), fetchGuideContentForAct()]).then((resList) => {
        const hornRes = resList[1];
        if (!hornRes) {
          throw new Error('horn 初始化失败，内容为空');
        }
        let activityConfig
        const activityGroupName = this.activityGroupName;
        const hornActGroupName = groupNameMapForHorn[activityGroupName];
        const bankType = this.bankType;
        activityConfig = hornRes[`activityConfig-${hornActGroupName}-${bankType}`];
        if (!activityConfig) {
          activityConfig = hornRes[`activityConfig-${hornActGroupName}`];
        }
        if (!activityConfig) {
          activityConfig = hornRes['activityConfig'] || {};
        }
        this.couponPackage =
          (activityConfig.couponPackage) || {};
        this.bankLogo = hornRes.bankLogo || {};
        this.bannerConfig = activityConfig[this.applyPageType] || {};
        this.couponImgForTOConfig = activityConfig['couponImgForT0'] || {};
        this.couponImgForTNConfig = activityConfig['couponImgForTN'] || {};
      }).catch((error) => {
        console.log('初始化失败', JSON.stringify(error));
      });
    },
    // 初始化业务信息
    async initBusinessInfo() {
      const isInMeituan = env.isInMeituan;
      const isInWaimai = env.isInWaimai;
      const isInMaicai = env.isInMaicai;
      const isInDianping = env.isInDianping;
      const isInMovie = env.isInMovie;
      const isInYouXuan = env.isInYouXuan;
      // 攻略页支持在美团&外卖访问
      if (!isInMeituan && !isInWaimai && !isInMaicai && !isInDianping && !isInMovie && !isInYouXuan) {
        ToastUtil.show('不支持当前App，请在美团App打开');
        return;
      }
      let location = env.commonParams.location;
      try {
        await this.$bridge.checkLocationService();
        if (location === '0_0' || location === '0.0_0.0') {
          // 定位异常时，降级处理，应用KNB定位信息
          try {
            const _res = await this.$bridge.getLocation();
            let { lat, lng } = _res;
            if (typeof(lat)==='undefined' || typeof(lng)==='undefined') {
              monitor.captureMessage(
                {
                  name: '【攻略页面-定位信息为空】',
                  msg: JSON.stringify(_res)
                },
                {
                  level: 'warn'
                }
              );
              lat = '0';
              lng = '0';
            }
            location = `${lat}_${lng}`;
            // 添加经纬度为0上报
            if (Number(lat) === 0 || Number(lng) === 0) {
              monitor.captureMessage(
                {
                  name: '【攻略页面-定位信息为0】',
                  msg: JSON.stringify(`${lat}_${lng}`)
                },
                {
                  level: 'warn'
                }
              );
            }
          } catch (err) {
            monitor.captureMessage(
              {
                name: '【攻略页面-定位信息异常】',
                msg: JSON.stringify(err)
              },
              {
                level: 'warn'
              }
            );
          }
        }
        const params = {
          activityName: this.activityName,
          activityId: this.activityId,
          activityGroupId: this.activityGroupName,
          nb_location: location,
        };
        await this.getGuideInfo(params);
      } catch (err) {
        monitor.captureMessage(
          {
            name: '【攻略页面-未开启定位】',
            msg: JSON.stringify(err)
          },
          {
            level: 'info'
          }
        );
        ToastUtil.show('获取位置信息失败，请打开定位权限');
      }
    },
    async getGuideInfo(params) {
      try {
        const res = await api.queryGuidePageV2(params);
        if (res.status === 'FAIL') {
          const failMessage = res && res.failMessage;
          ToastUtil.show(failMessage.title);
          monitor.captureMessage({
            name: '【攻略页面】接口状态异常',
            msg: JSON.stringify(failMessage)
          }, {
            level: 'info'
          });
          return;
        }
        if ( res.applyStatus === 'APPLY_FAIL' || res.applyStatus === 'UN_APPLY') {
          ToastUtil.show('请先报名参加活动');
          monitor.captureMessage({
            name: '【攻略页面】报名状态异常',
            msg: JSON.stringify(res)
            },
            {
              level: 'info'
            }
          );
          return;
        }
        this.applyStatus = res.applyStatus;
        this.mobileMask = res && res.mobileMask;
        this.hasOpenThatBank = res && res.currentBankWalletOpen;
        this.currentBankHasBinding = res && res.currentBankWalletBinding
        this.bankType = res && res.payType || '999';
        const resource = res && res.resource || {}
        this.bankList = resource.applyCommon && resource.applyCommon.bankList || [];
        const applyGuidePage = resource.applyGuidePage;
        this.backgroundUrl = applyGuidePage.headerImg;
        this.backgroundColor = applyGuidePage.background;
        this.activityRuleUrl = applyGuidePage.ruleLink;
        this.pageABStrategy = res.pageAbStrategy;
        this.applyPageType = res.applyPageType;
        this.pushSubWalletABStrategy = res.pushSubWalletAbStrategy;
      } catch (err) {
        console.log(err);
      }
    },
    goActivityRules() {
      this.$bridge.openPage(this.activityRuleUrl);
    }
  }
};
</script>
<style lang="less" scoped>
@import '../../../styles/base.less';
.guide {
  min-height: 100vh;
  width: 100%;
  padding: 3.75rem 0.2rem 0 0.24rem;
  position: relative;
  background-size: 100% auto;
  background-repeat: no-repeat;
  &-logo {
    position: absolute;
    top: 0;
    left: 0;
    width: 6.5rem;
    height: 0.62rem;
    background-size: auto 100%;
    background-repeat: no-repeat;
  }
  &-rule {
    position: absolute;
    right: 0;
    top: 0.26rem;
    z-index: 1;
    width: 0.43rem;
    height: 1.26rem;
    background-image: url('https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/activity-ruler-20220411.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  &-title {
    font-family: 'Meituan-Bold';
    font-size: 0.5rem;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 700;
    line-height: 0.7rem;
    position: absolute;
    top: 1.06rem;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
  }
  &-subTitle {
    background-image: linear-gradient(180deg, #208ce4 1%, #1ea4ff 100%);
    border-radius: 0.3rem;
    font-family: PingFangSC-Medium;
    font-size: 0.25rem;
    display: flex;
    align-items: center;
    position: absolute;
    top: 1.85rem;
    left: 50%;
    transform: translateX(-50%);
    height: 0.49rem;
    white-space: nowrap;
    &__middle {
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 500;
      line-height: 0.36rem;
      opacity: 1;
    }
    &__left {
      background-image: linear-gradient(270deg, #fffffe 0%, #59b5f5 100%);
      border-radius: 0.015rem;
      width: 0.2rem;
      height: 0.02rem;
      margin: auto 0.1rem;
    }
    &__right {
      background-image: linear-gradient(270deg, #fffffe 0%, #59b5f5 100%);
      border-radius: 0.015rem;
      width: 0.2rem;
      height: 0.02rem;
      margin: auto 0.1rem;
    }
  }
}
</style>
